"use client";

import PageLayout from "@template/layout/PageLayout";
import { Default as NavSectionComponentDef } from "@template/blocks/NavigationSection/NavigationSection.stories.ts";
import { Default as FooterSectionComponentDef } from "@template/blocks/FooterSection/FooterSection.stories.ts";
import FrameContent from "@admin/root/render/FrameContent";
import { StyleSheetManager } from "styled-components";
import { ReactNode, useEffect, useState } from "react";
import { useCurrentPageLoading } from "@helpers/hooks/useCurrentPageLoading";
import * as S from "./styles.ts";
import AdminTopBar from "@admin/root/render/AdminTopBar";
import { useTypedSelector } from "@/redux/helpers/hooks.ts";
import { LoadingSpinner } from "@template/components";
import ThemeProvider from "@template/theme/ThemeProvider.tsx";

const InjectFrameStyles = ({ children }: { children: ReactNode }) => {
  const iframe = document.querySelector("iframe#preview-frame") as any;
  const iframeDocument = iframe?.contentDocument;
  if (!iframeDocument) return children;

  return (
    <StyleSheetManager target={iframeDocument?.head}>
      {children}
    </StyleSheetManager>
  );
};

const render = ({ children, rootProps, liveMode }) => {
  const theme = useTypedSelector((state) => state.store.theme);
  const currentPageLoading = useCurrentPageLoading();

  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  const usedRoot = rootProps;

  const altLayout = usedRoot?.settings?.alt_layout;

  useEffect(() => {
    if (mounted) return;

    setMounted(true);

    const timer = 1;
    setTimeout(() => {
      setVisible(!visible);
    }, timer);
  }, []);

  if (liveMode) {
    return (
      <>
        <AdminTopBar type={rootProps.type} />
        <PageLayout
          navigation={{
            ...NavSectionComponentDef.args,
            altStyling: altLayout || false,
          }}
          footer={FooterSectionComponentDef.args as any}
        >
          {children}
        </PageLayout>
      </>
    );
  }

  if (!visible) return;

  if (currentPageLoading) {
    return (
      <S.LoadingContainer>
        <LoadingSpinner width={156} />
      </S.LoadingContainer>
    );
  }

  return (
    <InjectFrameStyles>
      <ThemeProvider
        theme={theme as any}
        type="import"
      >
        <FrameContent rootProps={rootProps}>{children}</FrameContent>
      </ThemeProvider>
    </InjectFrameStyles>
  );
};

export default render;
